import { Button } from "@/components/ui/button";
import { cn } from "@/libs/utils/common";
import { RefreshCw } from "lucide-react";
import { ReactNode } from "react";

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
  retryIcon?: ReactNode;
  heading?: string;
  /** Fill the nearest positioned ancestor. Set false to flow inline and let the container grow. */
  fill?: boolean;
}

export function ErrorMessage({
  message,
  onRetry,
  retryLabel = "Try again",
  retryIcon = <RefreshCw size={16} />,
  heading = "Something went wrong",
  fill = true,
}: ErrorMessageProps) {
  return (
    <div className={cn("flex items-center justify-center p-4", fill ? "absolute inset-0" : "w-full")}>
      <div className="text-center max-w-md">
        <div className="mb-6">
          <h1 className="text-2xl font-semibold text-gray-900 mb-2">{heading}</h1>
          <p className="text-gray-600 mb-6">{message}</p>
        </div>

        {onRetry && (
          <div>
            <Button onClick={onRetry} size="2" variant="secondary">
              <div className="flex items-center gap-2">
                {retryIcon}
                {retryLabel}
              </div>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
